const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/affiliates", // Add this entry
    exact: true,
    component: "Affiliates",
  },
];

export default routes;
